<template>
	<section class="page-accounting">
		<header-page
			actions
			name="accountant"
			:title="title"
			:value-disabled="valuesDisabled"
			@run-action="runAction"
		/>
		<app-actions
			:value-disabled="valuesDisabled"
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<backButtonRoute/>
		<accounting-filter
			:companies="companies"
			:subsidiary-id="params.subsidiaryId"
			:year-accountant-id="params.yearAccountantId"
			:years="years"
			hiden-company
			@filter="filterRows($event)"
		/>
		<div class="accounting-list">
			<app-table
				class="mt-3 is-not-selectable"
				name="accounting-planes"
				:columns="columns"
				:rows="rows"
				:last-page="lastPage"
				:items-total-quantity="itemsTotalQuantity"
				:items-quantity="rows.length"
				:current-page="currentPage"
				@on-page="changePage"
				@on-search-event="onSearchPlan($event)"
			>
				<template slot="rows" slot-scope="props">
					<td class="is-not-selectable description">
					{{ props.row.description }}
					</td>
					<td class="name">{{ props.row.subsidiary.name }}</td>
					<td class="year">{{ props.row.year }}</td>
					<td class="state">{{ props.row.flagActive === 1 ? 'Activo' : 'Inactivo' }}</td>
					<td @click.stop="stopClick" class="actions">
						<app-tooltip-button
							class="no-movil"
							img="/static/img/actions-list/detail.svg"
							text="Ver Detalle"
							:width="iconWidth"
							@click-icon="goToDetail(props.row)"
						/>
						<app-tooltip-button
							class="no-movil"
							img="/static/img/actions-list/square.svg"
							text="Clonar Plan de Cuentas"
							:width="iconWidth"
							@click-icon="openModal(props.row)"
						/>
						<app-tooltip-button
							class="no-movil"
							img="/static/img/actions-list/edit.svg"
							text="Editar Plan de Cuentas"
							:width="iconWidth"
							@click-icon="edit(props.row.id)"
						/>
						<app-tooltip-button
							class="no-movil"
							color="error"
							icon="delete"
							text="Eliminar Plan de Cuentas"
							@click-icon="confirmAccountPlanDeletion(props.row)"
						/>
					<div
						class="collapse-menu"
					>
						<v-menu>
							<v-btn dark icon slot="activator">
								<v-icon>more_horiz</v-icon>
							</v-btn>
							<v-list>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="goToDetail(props.row)">
										<img
											src="/static/img/actions-list/detail.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1 blue-icon">Ver Detalle</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="openModal(props.row)">
										<img
											src="/static/img/actions-list/square.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1 factory">Clonar Plan de Cuentas</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile>
									<v-list-tile-title class="menu-content" @click="edit(props.row.id)">
										<img
											src="/static/img/actions-list/edit.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1 edit">Editar Plan de Cuentas</span>
									</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
					</div>
					</td>
				</template>
			</app-table>
		</div>
	<!--	<section class="modal-filter-footer">
			<modal-sidebar-button
				hidden
				success-color="cyan"
				success-text="Atrás"
				@accept-button-clicked="goToBack"
			></modal-sidebar-button>
		</section>-->
		<v-dialog
			content-class="confirmation-dialog"
			v-model="modal"
			max-width="400"
		>
			<v-card class="pa-4">
				<v-card-text class="title text-xs-center pt-4">{{titleModal}}</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<button
						type="button"
						class="btn cancel"
						@click="closeModal"
					>
						No
					</button>
					<button
						type="button"
						class="btn agree"
						@click="onClone"
					>
						Si
					</button>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			content-class="confirmation-dialog"
			v-model="actionDeleteModal.modal"
			max-width="400"
		>
			<v-card class="pa-4">
				<v-card-text class="title text-xs-center pt-4">{{actionDeleteModal.titleModal}}</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<button
						type="button"
						class="btn cancel"
						@click="closeModalDelete"
					>
						No
					</button>
					<button
						type="button"
						class="btn agree"
						@click="deleteAccountPlan"
					>
						Si
					</button>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<router-view></router-view>
	</section>
</template>
<script>
import accountingFilter from '@/components/accounting-plans/accounting-filter';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import actionBar from '@/components/shared/action-bar/action-bar';
import appActions from '@/components/shared/app-actions/app-actions';
import backButtonRoute from '@/components/shared/back-button-route';
import { mapGetters } from 'vuex';

function created() {
	this.loadCompanies();
}

async function changePage(page) {
	this.currentPage = page;
	await this.loadAccounting();
}

function closeModal() {
	this.modal = false;
	this.titleModal = '';
	this.cloneId = '';
	this.clone.year = '';
	this.clone.description = '';
	this.clone.code = '';
	this.clone.customerId = '';
	this.clone.subsidiaryId = '';
}

function edit(id) {
	const subsidiaryId = this.subsidiaryId || null;
	this.goTo('accounting-edit', { params: { subsidiaryId, id } });
}

function filterRows({ value, model }) {
	this.params[model] = value.id;
	if (model === 'subsidiaryId') {
		this.subsidiaryName = value.name;
		this.params.yearAccountantId = null;
		this.loadYear(this.params.subsidiaryId);
	} else {
		this.loadAccounting();
	}
}

function goToDetail({ id, description, subsidiary, year }) {
	this.goTo('accounting-accounts',
		{ params:
			{
				id,
				name: description,
				subsidiaryName: subsidiary.name,
				year,
			},
		});
}

async function loadAccounting() {
	try {
		this.params.page = this.currentPage;
		const response = await this.$http.get('com-accounting-plan', { params: this.params });
		this.itemsTotalQuantity = Number(response.headers['x-quantity']);
		this.rows = response.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showGenericError();
	}
}

async function loadCompanies() {
	({ data: this.companies } = await this.$http.get('subsidiary'));
	if (this.subsidiaryId) {
		const value = this.companies.find(c => c.id === this.subsidiaryId) || {};
		this.params.subsidiaryId = this.subsidiaryId;
		this.subsidiaryName = value.name;
		this.loadYear(this.params.subsidiaryId);
	} else {
		this.loadAccounting();
	}
}

async function loadYear() {
	// const params = { subsidiaryId: id };
	({ data: this.years } = await this.$http.get('com-year-accountant'));
	this.loadAccounting();
}

async function onClone() {
	try {
		await this.$http.post(`com-accounting-plan/${this.cloneId}/clone`, this.clone);
		this.showNotification(`${this.clone.description} se clonó correctamente`);
		this.closeModal();
		this.loadAccounting();
	} catch (error) {
		this.showGenericError();
	}
}

function onSearchPlan(value) {
	this.params.search = value || null;
	this.loadAccounting();
}

function openModal({ id, year, description, code, customerId, subsidiaryId }) {
	this.titleModal = `¿Deseas Clonar este Plan de Cuentas: "${description}"?`;
	this.modal = true;
	this.clone.year = year;
	this.clone.description = description;
	this.clone.code = code;
	this.clone.customerId = customerId;
	this.clone.subsidiaryId = subsidiaryId;
	this.cloneId = id;
}

function runAction({ code, codeWeb }) {
	if (code === 'activate-accounting-plan') {
		const params = {};
		if (this.params.subsidiaryId && this.params.yearAccountantId) {
			params.subsidiaryId = this.params.subsidiaryId;
			params.yearAccountantId = this.params.yearAccountantId;
		} else if (this.params.subsidiaryId) {
			params.subsidiaryId = this.params.subsidiaryId;
		} else if (this.params.yearAccountantId) {
			params.yearAccountantId = this.params.yearAccountantId;
		}
		this.goTo(codeWeb, { params });
	} else if (code === 'accounting-plan-new') {
		const subsidiaryId = this.params.subsidiaryId || null;
		this.goTo('accounting-new', { params: { subsidiaryId } });
	}
}

function subsidiaryName(name) {
	const base = this.$route.meta.title;
	this.title = name ? `${name} - ${base}` : base;
}

function valuesDisabled() {
	const userI = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
	const notFranchise = userI && (userI.company.franchise === null || userI.company.franchise === 0);
	const fatherFranchise = userI && userI.company
		&& userI.company.franchise
		&& userI.subsidiary.father
		? userI.company.franchise === 1 && userI.subsidiary.father === 1 : false;
	const disabled = !this.subsidiaryName;
	return [
		{ code: 'accounting-plan-new', disabled: disabled || (!notFranchise && !fatherFranchise) },
		{ code: 'activate-accounting-plan', disabled: !notFranchise && !fatherFranchise },
	];
}

function goToBack() {
	this.goTo('companies');
}

function currentSubsidiary(newSub) {
	this.goTo('accounting-plans', { params: { subsidiaryId: newSub.id } });
}

// These functionalities are related to deleting account plans.
function confirmAccountPlanDeletion(row) {
	this.accountPlanDeletion = row;
	this.actionDeleteModal.titleModal = `¿Está seguro de que desea eliminar el Plan de Cuentas: "${row.description}"?`;
	this.actionDeleteModal.modal = true;
}

function closeModalDelete() {
	this.accountPlanDeletion = {};
	this.actionDeleteModal.titleModal = '';
	this.actionDeleteModal.modal = false;
}

async function deleteAccountPlan() {
	try {
		await this.$http.delete(`com-acounting-plan/${this.accountPlanDeletion.id}`);
		this.closeModalDelete();
		this.loadCompanies();
	} catch (error) {
		if (error.data.statusCode === 400 && error.data.message === 'ACCOUNTING_PLAN_RELATION') {
			this.showGenericError('No se Puede eliminar un Plan Asociado');
		} else {
			this.showGenericError();
		}
	}
}

function data() {
	return {
		companies: [],
		rows: [],
		lastPage: 0,
		currentPage: 1,
		columns: [
			{ id: 1, name: 'Plan de Cuentas', value: 'name', visible: true, checked: true, movil: true },
			{ id: 2, name: 'Empresa', value: 'subsidiary', visible: true, checked: true, movil: false },
			{ id: 3, name: 'Año Contable', value: 'year-accountant', visible: true, checked: true, movil: true },
			{ id: 3, name: 'Estado', value: 'state', visible: true, checked: true, movil: true },
			{ id: 4, name: 'Acción', value: 'action', visible: true, checked: true, movil: false },
		],
		disabledAction: true,
		years: [],
		companyId: 0,
		modal: false,
		titleModal: '',
		itemsTotalQuantity: null,
		clone: {
			year: '',
			description: '',
			code: '',
			customerId: '',
			subsidiaryId: '',
		},
		cloneId: '',
		subsidiaryName: '',
		title: this.$route.meta.title,
		iconWidth: 25,
		actionDeleteModal: {
			modal: false,
			titleModal: '',
		},
		accountPlanDeletion: {},
	};
}

export default {
	name: 'page-accounting-plans',
	components: {
		accountingFilter,
		appTooltipButton,
		actionBar,
		appActions,
		backButtonRoute,
	},
	computed: {
		...mapGetters('subsidiary', [
			'currentSubsidiary',
		]),
		valuesDisabled,
	},
	created,
	data,
	methods: {
		changePage,
		closeModal,
		edit,
		filterRows,
		goToDetail,
		loadAccounting,
		loadCompanies,
		loadYear,
		onClone,
		onSearchPlan,
		openModal,
		runAction,
		goToBack,
		confirmAccountPlanDeletion,
		closeModalDelete,
		deleteAccountPlan,
	},
	props: {
		subsidiaryId: [Number, String],
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'accounting-plans') {
					if (this.subsidiaryId) {
						const value = this.companies.find(c => c.id === this.subsidiaryId) || {};
						this.params.subsidiaryId = Number(this.subsidiaryId);
						this.subsidiaryName = value.name;
						this.loadYear(this.params.subsidiaryId);
					}
					this.loadAccounting();
				}
			}
		},
		subsidiaryName,
		currentSubsidiary,
	},
};
</script>
<style lang="scss" scoped>
	.btn {
		border-radius: 30px;
		color: white;
		height: 30px;
		padding: 0 10px;
		width: 90px;
	}

	.accounting-list {
		font-family: font(AvenirRegular) !important;
		font-size: size(small11) !important;
		padding-left: 48px;
		padding-right: 48px;

		@media (max-width: 768px) {
			margin-bottom: 60px;
			padding-left: 10px;
			padding-right: 10px;
		}
	}

	.collapse-menu {
		display: none;

		@media (max-width: 768px) {
			align-items: center;
			display: block;
			grid-column: 4/5;
			grid-row: 1;
			height: 100%;
			justify-content: center;

			.v-menu {
				align-items: center;
				display: flex;
				height: 100%;
				justify-content: center;

				.v-btn {
					background-color: color(btn-green);
					height: 25px;
					margin: 0;
					width: 25px;
				}
			}

		}
	}

	.menu-content {
		align-items: center;
		color: color(red-icon);
		display: grid;
		font-family: font(AvenirRegular);
		font-size: size(small) !important;
		grid-column-gap: 3px;
		grid-template-columns: 15px 1fr;
		width: 175px;

		.factory {
			color: color(secondary);
		}

		.edit {
			color: color(btn-green);
		}

		.blue-icon {
			color: color(blue-icon);
		}
	}

	.description {
		@media (max-width: 768px) {
			background-color: color(grey-background);
			display: grid;
			grid-column: 1/3;
			grid-row: 1;
		}
	}

	.actions {
		@media (max-width: 768px) {
			background-color: color(grey-background);
			grid-column: 3/4;
			grid-row: 1;
		}
	}

	.name {
		@media (max-width: 768px) {
			display: none;
		}
	}

	.year {
		@media (max-width: 768px) {
			background-color: white;
			display: grid;
			grid-column: 1/4;
			grid-row: 2;
		}
	}

	.btn {
		border-radius: 30px;
		color: white;
		height: 30px;
		padding: 0 10px;
		width: 90px;
	}

	.agree {
		background-color: color(secondary);
		margin-left: 10px;
	}

	.cancel {
		background-color: color(error);
		margin-right: 10px;
	}
	.btnActions {
		margin: 0;
		background-color:#33cfc7;
		height:20px;
		width:20px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/accounting-plans/page-accounting-plans.vue